import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { OnboardingService } from './onboarding.service';

/**
 * Redirects to /nutrition/onboarding when required nutrition parameters are missing.
 * Must NOT be applied to the onboarding route itself to avoid infinite redirects.
 */
export const nutritionOnboardingGuard: CanActivateFn = () => {
  const onboarding = inject(OnboardingService);
  const router = inject(Router);

  return onboarding.getStatus().pipe(
    map((status) => status.complete ? true : router.parseUrl('/nutrition/onboarding')),
    // Fail-closed: if we cannot confirm onboarding status, route to the wizard.
    // Letting users through on error allowed a network glitch to bypass onboarding
    // and land them on misconfigured nutrition pages.
    catchError(() => of(router.parseUrl('/nutrition/onboarding'))),
  );
};
